import { useEffect } from 'react';
import { Providers } from './providers';
import { AppRoutes } from './routes';
import { useAuth } from '@/features/auth/hooks/useAuth';

function AppContent() {
  const { initAuth } = useAuth();

  useEffect(() => {
    initAuth();
  }, [initAuth]);

  return <AppRoutes />;
}

export function App() {
  return (
    <Providers>
      <AppContent />
    </Providers>
  );
}
